<template>
    <dialog-modal :show="modal" @close="$emit('close', false)">
        <template #title>
            {{ $t("projects.updateTitle") }}
        </template>

        <template #content class="bg-white">
            <airtable-selector
                :errors="errorBags.default ? errorBags.default.airtable_record_id : false"
                :selected="form.airtable_record_id"
                type="projects"
                key-name="websiteUrl"
                @input="handleAirtableRecord"
            />

            <text-input
                v-model="form.name"
                :label="$t('projects.forms.name.title')"
                :errors="errors.name"
                class="mt-2"
            />

            <text-area-input
                v-model="form.description"
                :label="$t('projects.forms.description.title')"
                :errors="errors.description"
                class="mt-2"
            />

            <label for="airtable_record_id" class="block text-sm font-medium text-gray-700">{{
                $t("projects.forms.tenant.title")
            }}</label>
            <select
                id="airtable_record_id"
                v-model="form.tenant_id"
                name="airtable_record_id"
                class="
                    mt-1
                    block
                    w-full
                    pl-3
                    pr-10
                    py-2
                    text-base
                    border-gray-300
                    focus:outline-none
                    focus:ring-indigo-500
                    focus:border-indigo-500
                    sm:text-sm
                    rounded-md
                "
            >
                <option :value="false" disabled selected>Selecteer een Tenant</option>
                <option v-for="record in tenants" :key="record.id" :value="record.id">
                    {{ record.name }}
                </option>
            </select>
        </template>

        <template #footer>
            <div class="flex justify-between">
                <button-secondary button-style="danger" class="mr-auto" @click="closeModal" @button-click="closeModal()"
                    >{{ $t("incidents.buttons.cancel") }}
                </button-secondary>
                <button-primary class="mt-2 ml-auto" @click="submit">{{
                    $t("projects.buttons.update")
                }}</button-primary>
            </div>
        </template>
    </dialog-modal>
</template>

<script>
import DialogModal from "@/Jetstream/DialogModal";
import AirtableSelector from "@/Components/AirtableSelector";
import TextInput from "@/Components/TextInput";
import ButtonPrimary from "@/Components/ButtonPrimary";
import ButtonSecondary from "@/Components/ButtonSecondary";
import { Inertia } from "@inertiajs/inertia";
import { computed, reactive } from "vue";
import TextAreaInput from "@/Components/TextAreaInput";

export default {
    name: "UpdateProject",
    components: {
        TextAreaInput,
        DialogModal,
        AirtableSelector,
        ButtonPrimary,
        ButtonSecondary,
        TextInput,
    },
    props: {
        errorBags: Object,
        modal: [Object, Boolean],
        tenants: Object,
        project: Object,
    },
    emits: ["close"],
    setup(props, { emit }) {
        const form = reactive({
            name: props.project ? props.project.name : null,
            description: props.project ? props.project.description : null,
            tenant_id: props.project ? props.project.tenant_id : null,
            airtable_record_id: props.project ? props.project.airtable_record_id : null,
            _method: "PUT",
        });

        const submit = () => {
            Inertia.post(route("universal.projects.update", props.project.id), form, {
                forceFormData: true,
                // eslint-disable-next-line vue/no-mutating-props
                onSuccess: () => emit("close", false),
            });
        };

        const errors = computed(() => (props.errorBags.default ? props.errorBags.default : {}));

        const handleAirtableRecord = (value) => {
            form.airtable_record_id = value;
        };
        const handleTenantSelected = (value) => {
            form.tenant_id = value;
        };

        const closeModal = () => {
            emit("close", false);
            Inertia.visit(route("universal.projects.index"));
        };

        return {
            form,
            errors,
            handleAirtableRecord,
            handleTenantSelected,
            closeModal,
            submit,
        };
    },
};
</script>
